import Manager from './manager.vue';

import Product from './regular/product.vue';
import CustomProduct from './custom/product.vue';

import OrderManager from './orderManager.vue';

import Summary from './regular/steps/summary.vue';
import Information from './regular/steps/information.vue';
import Delivery from './regular/steps/delivery.vue';
import Approve from './regular/steps/approve.vue';
import OrderComplete from './regular/steps/completedOrder.vue';
import OrderFailed from './regular/steps/failedOrder.vue';
import CardFailed from './regular/steps/failedCard.vue';

import CustomSummary from './custom/steps/summary.vue';
import CustomInformation from './custom/steps/information.vue';
import CustomDelivery from './custom/steps/delivery.vue';
import CustomApprove from './custom/steps/approve.vue';
import CustomOrderComplete from './custom/steps/completedOrder.vue';
import CustomOrderFailed from './custom/steps/failedOrder.vue';
import CustomCardFailed from './custom/steps/failedCard.vue';



export const routes = [
    {path: '/make-order/:type/:id', name: 'make-order.manage', component: Manager, children: [
        {path: 'regular', name:'make-order.product', component:Product},
        {path: 'custom', name:'make-order.custom.product', component:CustomProduct},

        {path: 'order', name:'make-order.order', component:OrderManager, redirect: {name: 'make-order.order.summary'},
            children:[
                { path:'summary', name:'make-order.order.summary', component:Summary },
                { path:'information', name:'make-order.order.information', component:Information },
                { path:'delivery', name:'make-order.order.delivery', component:Delivery },
                { path:'approve', name:'make-order.order.approve', component:Approve },
            ]},

        {path: 'custom/order', name:'make-order.custom.order', component:OrderManager, redirect: {name: 'make-order.custom.order.summary'},
            children:[
                { path:'summary', name:'make-order.custom.order.summary', component:CustomSummary},
                { path:'information', name:'make-order.custom.order.information', component:CustomInformation },
                { path:'delivery', name:'make-order.custom.order.delivery', component:CustomDelivery },
                { path:'approve', name:'make-order.custom.order.approve', component:CustomApprove },

            ]},

        {path: 'order/complete', name:'make-order.order.complete', component:OrderComplete},
        {path: 'order/failed', name:'make-order.order.failed', component:OrderFailed},
        {path: 'order/card/failed', name:'make-order.order.card.failed', component:CardFailed},

        {path: 'custom/order/complete', name:'make-order.custom.order.complete', component:CustomOrderComplete},
        {path: 'custom/order/failed', name:'make-order.custom.order.failed', component:CustomOrderFailed},
        {path: 'custom/order/card/failed', name:'make-order.custom.order.card.failed', component:CustomCardFailed},
    ]},

];
